// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3wOos","inner":"Footer_inner__kN9LK"};